/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useContext, useRef } from "react";
import { purchaseService } from "../../services/purchase.service";
import { Dropdown } from "react-bootstrap";
import LogicContext from "../../Context/LogicContext";
import {
  GetRecoilBillListData,
  SetRecoilBillListData,
} from "../../store/billsAtom";
// import CurrencyFormat from 'react-currency-format';
import Tooltip from "@mui/material/Tooltip";
import RestartAlt from "@mui/icons-material/RestartAlt";
import { useState } from "react";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { useLocation, useNavigate } from "react-router-dom";

import ActionPaneComponent from "../../helpers/ActionPaneComponent";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import { useForm } from "react-hook-form";
import moment from "moment";
import { toLowercaseKeys } from "../../helpers/toLowerCaseKeys";
import BillPageFilter from "./BillPageFilter";
import StatusBadge from "../../generals/StatusBadge";


const columns = [
  {
    title: 'Group Name',
    key: 'Bill_Date_String',
    dataIndex: 'Bill_Date_String',
    sorter: (a, b) => (a?.Bill_Date_String ?? '').localeCompare(b?.Bill_Date_String ?? ''),
    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },
  {
    title: 'Id',
    key: 'Bill_Ref_No',
    dataIndex: 'Bill_Ref_No',
    className: 'text-primary',

    sorter: (a, b) => (a?.Bill_Ref_No ?? '') - (b?.Bill_Ref_No ?? ''),

    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },

  {
    title: 'Bill Number',
    dataIndex: 'Bill_Number',
    sorter: (a, b) => (a?.Bill_Number ?? '').localeCompare(b?.Bill_Number ?? ''),

    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },
  {
    title: 'Vendor Name',
    dataIndex: 'Vendor_Name',
    sorter: (a, b) => (a?.Vendor_Name ?? '').localeCompare(b?.Vendor_Name ?? ''),
    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },

  {
    title: 'Amount',
    dataIndex: 'Bill_Amount',
    sorter: (a, b) => (a?.Bill_Amount ?? '') - (b?.Bill_Amount ?? ''),
    render: record => <span> {formatCustomNumber(record)} </span>,
  },

  {
    title: 'Balance Due Amount',
    dataIndex: 'Balance_Due_Amount',
    sorter: (a, b) => (a?.Balance_Due_Amount ?? '') - (b?.Balance_Due_Amount ?? ''),
    render: record => <span> {formatCustomNumber(record)} </span>,

    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },

  {
    title: 'Status',
    dataIndex: 'Bill_Status_Name',
    sorter: (a, b) => (a?.Bill_Status_Name ?? '').localeCompare(b?.Bill_Status_Name ?? ''),
    render: (record, row) => (
      <StatusBadge statusId={row?.Bill_Status_Id} statusName={record} />
    ),
  },
];


function BillPage() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const logicContext = useContext(LogicContext);
  const setBillListData = SetRecoilBillListData();
  const getBillListData = GetRecoilBillListData();
  const myPromiseModal = createModal(GeneralModal);

  const [tableData, setTableData] = useState([]);
  const [itemSelected, setItemSelected] = useState([]);
  const mountRef = useRef(false);
  

    const {   register,  setValue,  getValues,   handleSubmit,
      reset, formState: { errors }  } = useForm();



  useEffect(() => {
    document.title = "Bills";
    let isMounted = true;
    if (getBillListData["Bill_Info"]?.length > 0) {
      setTableData(getBillListData["Bill_Info"]);
      let newList = getBillListData["Bill_Info"].filter(
        (bill) => bill.Bill_Status_Id === 2
      );
    }else{
      getBillsListApi();
    }
    return () => {
      isMounted = false;
    };
  }, [getBillListData]);

  const getBillsListApi = async () => {
    purchaseService.getBillsList().then((response) => {
      if (response?.data !== undefined) {
        setBillListData(response.data);
      }
    });
  };

  const onFilterSelect = (action) => {
    const option = action.Filtering_Field_Value;
    if (Number(option) === 0) {
      return setTableData(getBillListData["Bill_Info"]);
    }
    var newList = getBillListData["Bill_Info"].filter(
      (item) => item.Bill_Status_Id === Number(option)
    );
    if(newList?.length){
      setTableData(newList);
    }else{
      setTableData([]);
    }
  };

  function selectedTableItems(itemList) {
    setItemSelected(itemList);
  }

  function addNewInvoice() {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
  }

  async function bulkActions(action) {
  
    await myPromiseModal({
      title: "confirm your action!",
      body: `Do you want to ${action.Action_Name} ?`,
      showInput: false,
      placeHolder: "",
    }).then((result) => {
      if (result.decision === true) {
        let temp = "";
        const option = action.Procedure_Option;
        itemSelected.map((item) => {
          temp += `<a> <refno> ${item.Bill_Ref_No} </refno> </a>`;
        });

        let xml_string_refno = `<root> ${temp} </root>`;
        purchaseService
          .setBillBulkAction({ xml_string_refno, option })
          .then((res) => {
            if (res?.data !== undefined) {
              const { message_text } = res.data[0];
              logicContext.showToast(message_text, "success");
              return getBillsListApi();
            }
          })
          .catch((err) => {
            logicContext.showToast("Error", "error");
          });
      }
    });
  }

  function handleRowClick(event) {
    const id = event["Bill_Ref_No"];
    navigate(
      `/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`
    );
  }



    const searchByDate = async (event) => {
      const formData = getValues();
      const response = await purchaseService.getBillsListByDate(formData);
      if (response?.data?.length) {
        setTableData(response?.data);
      } else {
        logicContext.showToast("No result found", "");
        setTableData([]);
      }
    };

  return (
    <>
      <section>
        <section className="bg-white  px-2    md:flex justify-between ">
          <div className="flex px-2 mt-1">
            {itemSelected.length > 0 ? (
              <div className="row">
                <div className="col col-md-4">
                  <Dropdown>
                    <Dropdown.Toggle
                      style={{
                        backgroundColor: '#E5E5E5',
                        border: 'none',
                        color: '#45444B',
                        fontSize: '12px',
                        height: '45px',
                      }}
                      id="dropdown-basic"
                    >
                      Bulk Actions
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {getBillListData['Bulk_Action']?.map((action, i) => {
                        return (
                          <Dropdown.Item key={i} onClick={() => bulkActions(action)}>
                            {action.Action_Name}
                          </Dropdown.Item>
                        );
                      })}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            ) : (
              // <ActionPaneComponent
              //   bulkActionData={toLowercaseKeys(getBillListData['Filtering_Criteria'])}
              //   onSelectBulkAction={onActionFilterPerform}
              // />
              <BillPageFilter list={getBillListData['Filtering_Criteria']} onFilterSelect={onFilterSelect} />
            )}

            <Tooltip title="Reload">
              <RestartAlt className="cursor ml-2 mt-1" onClick={() => getBillsListApi()} color="primary" fontSize="large" />
            </Tooltip>
          </div>

          {/* date search */}
          <div class="flex flex-row items-end space-x-2">
            <div>
              <span className="ml-1 text-sm ">From Date:</span>
              <input
                defaultValue={moment(Date.now()).format('YYYY-MM-DD')}
                {...register('from_date')}
                className=" bg-white ring-1 ring-gray-200  w-full pl-3  rounded max-h-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
                type="date"
              />
            </div>

            <div>
              <span className="ml-1 text-sm ">To Date:</span>
              <input
                {...register('to_date')}
                defaultValue={moment(Date.now()).format('YYYY-MM-DD')}
                className=" bg-white ring-1 ring-gray-200  w-full pl-3  rounded max-h-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
                type="date"
              />
            </div>
            <div>
              <button onClick={() => searchByDate()} type="button" className="text-sm text-white px-3 bg-blue-500 rounded py-2.5">
                Search
              </button>
            </div>
          </div>
          {/* date search end */}

          <div className="flex justify-between">
            <button className="  font-[Poppins] font-bold py-2 mt-1 px-2 rounded md:ml-8 text-sm">IMPORT</button>
            <div className="btn-group">
              <button
                className=" font-[Poppins] font-bold py-2 mt-1 px-2 rounded md:ml-8   text-sm"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                EXPORT
              </button>
            </div>

            <button
              onClick={addNewInvoice}
              className="bg-buttonColor font-[Poppins] py-3 mt-1 mr-1 px-3 rounded md:ml-8  text-white text-xs"
            >
              ADD NEW
            </button>
          </div>
        </section>

        <section className="mt-5">
          <GeneralCustomTable
            tableHeadList={columns}
            tableDataList={tableData}
            allowCheckBox={true} // show checkBox for each row
            setSelectedRows={selectedTableItems}
            rowKey={record => record.Bill_Ref_No} // custom key
            handleRowClick={handleRowClick}
          />
        </section>
      </section>
    </>
  );
}

export default BillPage;
